/* eslint-disable */
import backbone from 'backbone';
import _ from 'underscore';
import odata from '@bingads-webui-static-legacy/communication/channel/odata';
var Job = backbone.Model.extend({
  defaults: {
    Id: null,
    Selection: '',
    TotalRowCount: 0,
    SuccessRowCount: 0,
    ErrorRowCount: 0,
    Status: '',
    CreationTime: '',
    ExecutionStartTime: '',
    CompletionTime: '',
    CreatedBy: '',
    BulkEditResults: [],
    selectedEntityCount: 0,
    PreviewEntityIds: [],
    PreviewCompositeIds: []
  },
  updateSummaryDataContext: function (metadata, action, url) {
    var entityType = this.get('Entity');
    var isPreviewMode = url.indexOf('preview') > 0;
    if (metadata && entityType) {
      switch (entityType) {
        case 'Campaign':
          metadata.gridIds = ['CampaignsGrid'];
          if (!isPreviewMode) {
            metadata.dependentIds = ['CampaignsGrid', 'AdGroupGrid', 'PagedAdGroupGrid', 'AdGrid', 'KeywordGrid', 'AudiencesAssociationGrid', 'SitePlacementGrid', 'CampaignsSettingsGrid', 'AccountAdExtensionsGrid', 'CampaignAdExtensionsGrid', 'AdGroupAdExtensionsGrid'];
          }
          break;
        case 'AdGroup':
          metadata.gridIds = ['AdGroupGrid'];
          if (!isPreviewMode) {
            metadata.dependentIds = ['CampaignsGrid', 'AdGroupGrid', 'PagedAdGroupGrid', 'AdGrid', 'KeywordGrid', 'AudiencesAssociationGrid', 'SitePlacementGrid', 'AccountAdExtensionsGrid', 'CampaignAdExtensionsGrid', 'AdGroupAdExtensionsGrid'];
          }
          break;
        case 'Keyword':
          metadata.gridIds = ['KeywordGrid'];
          if (!isPreviewMode) {
            metadata.dependentIds = ['KeywordGrid'];
          }
          break;
        case 'Ad':
          metadata.gridIds = ['AdGrid'];
          if (!isPreviewMode) {
            metadata.dependentIds = ['AdGrid'];
          }
          break;
        case 'AudienceAssociation':
        case 'AdGroupAudienceAssociation':
          metadata.gridIds = ['AudiencesAssociationGrid'];
          if (!isPreviewMode) {
            metadata.dependentIds = ['AudiencesAssociationGrid'];
          }
          break;
        case 'CampaignCriterion':
          metadata.gridIds = ['CampaignSettingsGrid'];
          if (!isPreviewMode) {
            metadata.dependentIds = ['CampaignSettingsGrid'];
          }
          break;
        case 'AdGroupCriterion':
          metadata.gridIds = ['AdGroupSettingsGrid'];
          if (!isPreviewMode) {
            metadata.dependentIds = ['AdGroupSettingsGrid'];
          }
          break;
        case 'PerformanceTarget':
          metadata.gridIds = ['PerformanceTargetsSummaryGrid'];
          if (!isPreviewMode) {
            metadata.dependentIds = ['PerformanceTargetsSummaryGrid'];
          }
          break;
      }
    }
    return metadata;
  },
  parse: function (response) {
    if (response) {
      return {
        Id: response.Id.length > 0 ? response.Id : null,
        Selection: response.Selection,
        Description: response.Description,
        TotalRowCount: response.TotalRowCount,
        SuccessRowCount: response.SuccessRowCount,
        ErrorRowCount: response.ErrorRowCount,
        Status: response.Status,
        CreationTime: response.CreationTime,
        ExecutionStartTime: response.ExecutionStartTime,
        CompletionTime: response.CompletionTime,
        CreatedBy: response.CreatedBy,
        BulkEditResults: response.BulkEditResults,
        UserErrors: response.UserErrors
      };
    }
    return undefined;
  },
  sync: function (method, model, options) {
    var url = _.template(this.url)({
      jobId: this.get('Id')
    });
    if (method === 'create') {
      options.type = 'Post';
      var data = {
        'Entity': model.get('Entity'),
        'BatchAction': model.get('BatchAction'),
        'Selection': model.get('Selection'),
        'Description': model.get('Description'),
        'PreviewEntityIds': model.get('PreviewEntityIds'),
        'PreviewCompositeIds': model.get('PreviewCompositeIds')
      };
      if (model.get('RequestProperties')) {
        data['RequestProperties'] = model.get('RequestProperties');
      }
      if (model.get('CurrentCustomerId')) {
        data['CurrentCustomerId'] = model.get('CurrentCustomerId');
      }
      options.data = JSON.stringify(data);
      if (model.get('currentCustomerIdFirst')) {
        options.currentCustomerIdFirst = true;
      }
    } else {
      options.type = 'Get';
    }
    return odata.jq_ajax_adapter.call(this, url, options);
  },
  idAttribute: 'Id'
});
export default Job;

